export const termosECondicoes = {
  Nenhum: { Enum: 0, Descricao: "", Icon: { Type: "", Color: ""}},
  Aguardando: { Enum: 1, Descricao: "Aguardando", Icon: { Type: "clock-circle", Color: "#A9A9A9"}},
  Aceitou: { Enum: 2, Descricao: "Aceitou", Icon: { Type: "check-circle", Color: "#3E9369"}},
  Recusou: { Enum: 3, Descricao: "Recusou", Icon: { Type: "close-circle", Color: "#C95958"}}
}

export const findByEnum = status =>
  termosECondicoes[Object.keys(termosECondicoes).find(key => termosECondicoes[key].Enum == status)]

export const termosECondicoesToList = () =>
  Object.keys(termosECondicoes)
    .filter(key => termosECondicoes[key].Enum != termosECondicoes.Nenhum.Enum)
    .map(key => termosECondicoes[key])
